"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var CartViewStyles = require("../panels/CartViewPanel/CartViewPanel.scss");
var CartCommon_scss_1 = require("../../styles/CartCommon.scss");
var wlsStyles = require("../CartLob/WirelessCart/WirelessCart.scss");
var styles = require("./CartConfiguration.scss");
var icons = require("../../styles/ccc-icons-cart.scss");
var ui_components_1 = require("@idp/ui-components");
var localdatastore_1 = require("../../config/localdatastore");
var PromoPanel_1 = require("../panels/PromoPanel");
var cms_integration_1 = require("@idp/cms-integration");
var Cart_cms_1 = require("../../cms/Cart.cms");
var WirelessCart_1 = require("../CartLob/WirelessCart");
var BroadbandCart_1 = require("../CartLob/BroadbandCart");
var AccessoriesCart_1 = require("../CartLob/AccessoriesCart");
var CollapsedCartView_1 = require("../CartLob/CollapsedCartView");
var Utils = require("../../utils/UtilityFunctions");
var cartUtils = require("../../utils/CartUtilFunctions");
var IncompleteCart_1 = require("../atoms/IncompleteCart");
var FutureBills_1 = require("../FutureBills");
var SaveRetrieveCart_1 = require("../cards/SaveRetrieveCart");
var ShareCart_1 = require("../CartLob/shared/ShareCart");
var EmptyCart_1 = require("../CartLob/shared/EmptyCart");
var event_bus_1 = require("@idp/event-bus");
var ui_components_2 = require("@idp/ui-components");
var MessageProps_1 = require("@idp/ui-components/components/atoms/Message/MessageProps");
var ReportingService_1 = require("../../api/ReportingService");
var utils_1 = require("@idp/ui-components/utils");
var routables_1 = require("@idp/routables");
var OrderTotals_1 = require("../panels/OrderTotals/OrderTotals");
var AdvertismentPanel_cms_1 = require("./AdvertismentPanel.cms");
var Events_1 = require("../../api/Events");
var ExpressView_1 = require("../CartLob/ExpressView");
var MonthlySavings_1 = require("../../components/CartLob/shared/MonthlySavings");
var components_1 = require("@idp/duc/components");
var wlsUtils = require("../../utils/WirelessUtilFunctions");
var LabelProps_1 = require("@idp/ui-components/components/atoms/Label/LabelProps");
var promoStyle = require("../panels/PromoPanel/PromoPanel.scss");
var CartConfiguration_scss_1 = require("./CartConfiguration.scss");
var CartConfigurationExtender_1 = require("./CartConfigurationExtender/CartConfigurationExtender");
var BusinessTools_1 = require("../CartLob/BusinessTools");
var InsuranceModel_1 = require("../CartLob/shared/InsuranceModel/InsuranceModel");
var CartConfiguration = /** @class */ (function (_super) {
    __extends(CartConfiguration, _super);
    function CartConfiguration(props) {
        var _this = _super.call(this, props) || this;
        _this.configConsole = null;
        _this.showSaveCartLinks = false;
        _this.showShareCartLink = false;
        _this.onCartLOBUpdate = 'onCartLOBUpdate';
        _this.isExpressUpgradeView = false;
        _this.displayCartInCollapsedMode = false;
        _this.isCommonCart = false;
        _this.savingsPromoFlags = {};
        _this.isExternalOrderSource = '';
        _this.isWirelessAccCart = false;
        _this.showTVLaterBBExperience = wlsUtils === null || wlsUtils === void 0 ? void 0 : wlsUtils.showTVLaterBBExperience();
        _this.setInsuranceDetails = function () { return __awaiter(_this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.insuranceDetails = JSON.parse(wlsUtils.getInsuranceDetails());
                        if (!this.insuranceDetails) return [3 /*break*/, 1];
                        this.stateManager.set('insuranceDetails', this.insuranceDetails);
                        return [3 /*break*/, 3];
                    case 1: return [4 /*yield*/, this.api.getInsuranceDetails().then(function (response) {
                            _this.insuranceDetails = response;
                            _this.stateManager.set('insuranceDetails', __assign({}, _this.insuranceDetails));
                        }).catch(function (error) {
                            console.error(error);
                        })];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        _this.state = {
            insuranceModalFromCheckout: false,
            isBundleCart: false,
            showAdvertismentBanner: true,
        };
        _this.priceBarUpdate = {
            dueMonthly: 0,
            dueOneTime: 0,
            dueToday: 0,
            isAmtProvidedTaxInclusive: false,
            readyToCheckout: false,
        };
        _this.wlsCMS = wlsUtils.getWlsCmsData();
        _this.savecartModalRef = React.createRef();
        _this.cartPriceBarUpdates = _this.cartPriceBarUpdates.bind(_this);
        _this.refreshCartSummary = _this.refreshCartSummary.bind(_this);
        _this.registerCartResponseChanged = _this.registerCartResponseChanged.bind(_this);
        _this.updatePriceBarEvent = _this.updatePriceBarEvent.bind(_this);
        _this.renderSisfoAlert = _this.renderSisfoAlert.bind(_this);
        _this.onLobEdit = _this.onLobEdit.bind(_this);
        _this.authSaveCartMessage = _this.authSaveCartMessage.bind(_this);
        _this.renderCollapsedCart = _this.renderCollapsedCart.bind(_this);
        _this.renderShareCartLink = _this.renderShareCartLink.bind(_this);
        _this.renderSharedRetrieveCartMessage = _this.renderSharedRetrieveCartMessage.bind(_this);
        _this.showSaveCartModal = _this.showSaveCartModal.bind(_this);
        _this.renderExpressView = _this.renderExpressView.bind(_this);
        _this.renderMonthlySavings = _this.renderMonthlySavings.bind(_this);
        _this.renderUpsellPromoChangedBanner = _this.renderUpsellPromoChangedBanner.bind(_this);
        _this.changePlanOfferMessage = _this.changePlanOfferMessage.bind(_this);
        _this.showBauCart = _this.showBauCart.bind(_this);
        _this.showCommonCart = _this.showCommonCart.bind(_this);
        _this.showPersonalizedPricing = _this.showPersonalizedPricing.bind(_this);
        _this.showPersonalizedPricingModal = _this.showPersonalizedPricingModal.bind(_this);
        _this.getMonthlySavingsResponse = _this.getMonthlySavingsResponse.bind(_this);
        _this.renderAddMoreAccessory = _this.renderAddMoreAccessory.bind(_this);
        _this.showAddALine = _this.showAddALine.bind(_this);
        _this.onlyBBInCartWithSessionData = Utils.IsBroadbandInCart() && !!sessionStorage.getItem('TVBBSplitBill');
        _this.registerZipModalObserver = _this.registerZipModalObserver.bind(_this);
        _this.zipCodeUpdateModal = _this.zipCodeUpdateModal.bind(_this);
        _this.triggerCartSummaryEvents = _this.triggerCartSummaryEvents.bind(_this);
        return _this;
    }
    CartConfiguration.prototype.componentWillMount = function () {
        this.events = new Events_1.default([this.onCartLOBUpdate]);
        this.payload = Utils.getCartResp();
        this.isCommonCart = Utils.isCommonCartPresent(this.payload);
    };
    CartConfiguration.prototype.componentDidMount = function () {
        this.id = event_bus_1.ICCEventBusManager.getUUID();
        this.registerCartResponseChanged();
        this.registerZipModalObserver();
        this.updatePriceBarEvent();
        this.registerNoCommonDeliveryEvent();
        if (this.finalLobOrigin && this.finalLobOrigin._cartOrigin &&
            (/OPUS/i).test(this.finalLobOrigin._cartOrigin)) {
            this.reportingService.fireSisfoConfirmSystemEvent('STORE');
        }
        this.showBundlesTreatment = this.props.options && !!this.props.options.showBundlesTreatment;
        if (cartUtils.getPostpaidflowtype() === 'UP') {
            this.setInsuranceDetails();
        }
        this.triggerCartSummaryEvents();
    };
    CartConfiguration.prototype.registerZipModalObserver = function () {
        var _this = this;
        var zipObserver = {
            eventHandler: function () { _this.zipCodeUpdateModal(); },
            observerId: this.id,
            serviceName: 'CART:zipUpdate',
        };
        event_bus_1.ICCEventBusManager.getInstance().registerObserver(zipObserver);
    };
    CartConfiguration.prototype.zipCodeUpdateModal = function () {
        var showModal = this.stateManager.get('CART', 'zipUpdate');
        this.setState({ showInsuranceModal: showModal.openModal, insuranceModalFromCheckout: true });
        if (showModal.openModal) {
            this.reportingService.firePageLoadEvent(cartUtils.getLinkClickBasekUrl());
        }
    };
    CartConfiguration.prototype.registerNoCommonDeliveryEvent = function () {
        var zipObserver = {
            eventHandler: this.setNoCommonDeliveryErrorState,
            observerId: this.id,
            serviceName: 'CHECKOUT:rtiNoCommonDelivery',
        };
        event_bus_1.ICCEventBusManager.getInstance().registerObserver(zipObserver);
    };
    CartConfiguration.prototype.registerCartResponseChanged = function () {
        var _this = this;
        var cartResponsChangedObserver = {
            eventHandler: function () { _this.refreshCartSummary(); },
            observerId: this.id,
            serviceName: 'appShell:cartResponse',
        };
        event_bus_1.ICCEventBusManager.getInstance().registerObserver(cartResponsChangedObserver);
    };
    CartConfiguration.prototype.refreshCartSummary = function () {
        var isDeviceUpdated = this.stateManager.get(localdatastore_1.getNamespace('CART'), 'deviceUpdate');
        if (isDeviceUpdated && isDeviceUpdated.deviceConfigRefresh) {
            this.events.fireEvent({
                reason: 'OnLOBRemoval',
            }, this.onCartLOBUpdate);
            this.stateManager.set('deviceUpdate', { deviceConfigRefresh: false });
        }
        this.payload = Utils.getCartResp();
        this.updatePriceBarEvent();
    };
    CartConfiguration.prototype.triggerCartSummaryEvents = function () {
        var _this = this;
        var _a;
        this.formattedInsuranceDetails = wlsUtils.getReportingInsuranceDetails((_a = this.insuranceDetails) === null || _a === void 0 ? void 0 : _a.content);
        var formattedExistingPlanDetails = wlsUtils.getExistingPlanName();
        if (formattedExistingPlanDetails) {
            this.formattedInsuranceDetails.push(formattedExistingPlanDetails);
        }
        this.fireCartPageReportingEvents(this.formattedInsuranceDetails);
        var url = location.href.toLowerCase();
        var isParamVal = (/source=/i).test(url);
        if (isParamVal) {
            setTimeout(function () {
                _this.reportingService.fireRetrieveCartDisplay();
            }, 2000);
        }
    };
    CartConfiguration.prototype.updatePriceBarEvent = function () {
        if (this.payload
            && this.payload.orderPriceInfo && Utils.getCartStatus()) {
            this.priceBarUpdate = Utils.getPriceBarData(this.payload);
            if (!(/checkout/i).test(location.href)) {
                this.stateManager.set('priceBarUpdate', this.priceBarUpdate);
            }
            this.isExpressUpgradeView = cartUtils.isExpupgradeViewEnable();
            this.savingsPromoFlags = cartUtils.getSavingsPromoFlags();
            this.isExternalOrderSource = wlsUtils.externalOrderSource(this.payload);
            this.showSaveCartLinks = (this.payload.saveCartLinks &&
                this.payload.saveCartLinks.length > 0) || false;
            this.showShareCartLink = !!(cartUtils.checkShareCartEligibility() && !this.payload.authDetails);
            var currentLob = Utils.getCurrentLOB();
            if (currentLob) {
                var finalLob = currentLob.toLowerCase().concat('Cart');
                this.finalLobOrigin = this.payload[finalLob];
                this.setState({ checkSisfoResponse: true });
            }
            if (wlsUtils.isMonthlySavings()) {
                this.getMonthlySavingsResponse(true);
            }
        }
    };
    CartConfiguration.prototype.cartPriceBarUpdates = function (isUpdate) {
        if (isUpdate) {
            this.updatePriceBarEvent();
        }
    };
    CartConfiguration.prototype.onLobEdit = function (lobType, editLinkUrl, editText) {
        var editLink = Utils.getEditLinkUrl(editLinkUrl);
        var reportingEditText = editText ? editText : 'Edit';
        this.reportingService.fireLinkClickWithOutPageLoad(reportingEditText, editLink);
        this.stateManager.set('editLinkUrl', { url: editLink });
        this.stateManager.set('CurrentPageURL', { name: editLink });
        if ((editLink.indexOf('.html') > -1 || editLink.indexOf('phones') > -1
            || editLink.indexOf('hub') > -1 || editLink.indexOf('byod') > -1
            || editLink.indexOf('broadband') > -1 || editLinkUrl.indexOf('postpaid') > -1)
            && typeof window !== undefined) {
            window.location.href = "/buy" + editLink;
        }
        else {
            this.props.events.onEdit(lobType);
            routables_1.history.push(editLink);
        }
    };
    CartConfiguration.prototype.authSaveCartMessage = function (msgText, iconType) {
        this.errorMsgText = msgText;
        this.errorMsgIconType = iconType;
        this.setState({ isShowErrorMessage: true });
    };
    CartConfiguration.prototype.handleStandaloneCRPMessage = function () {
        this.setState({ isStandaloneCRP: true });
    };
    CartConfiguration.prototype.renderLoading = function () {
        if (this.state.isLoading) {
            return (React.createElement("div", { className: styles.loaderShow },
                React.createElement(ui_components_2.InfiniteLoader, null)));
        }
        else {
            return (React.createElement(React.Fragment, null, " "));
        }
    };
    CartConfiguration.prototype.render = function () {
        var _a, _b;
        var cmsDataCC = cms_integration_1.CMS.get(new Cart_cms_1.CartCms(), 'cartcheckout').content.common;
        this.cartSummaryCMSData = cmsDataCC === null || cmsDataCC === void 0 ? void 0 : cmsDataCC.sisfoOrder;
        this.cartConfigurationCMSData = cmsDataCC === null || cmsDataCC === void 0 ? void 0 : cmsDataCC.cartConfiguration;
        this.saveRetrieveCMSData = cmsDataCC === null || cmsDataCC === void 0 ? void 0 : cmsDataCC.saveRetrieveCart;
        this.campaignCouponCmsData = cmsDataCC === null || cmsDataCC === void 0 ? void 0 : cmsDataCC.campaignCoupons;
        this.wirelessCmsData = cmsDataCC === null || cmsDataCC === void 0 ? void 0 : cmsDataCC.cartSummary;
        this.cookieVal = Utils.getCookie('sourceCode');
        this.advertismentCMSData = (cmsDataCC === null || cmsDataCC === void 0 ? void 0 : cmsDataCC.advertismentPanel) || new AdvertismentPanel_cms_1.AdvertismentPanelCms();
        this.displayCartInCollapsedMode = false;
        if ((_b = (_a = this.props) === null || _a === void 0 ? void 0 : _a.options) === null || _b === void 0 ? void 0 : _b.displayCartInCollapsedState) {
            this.displayCartInCollapsedMode = true;
        }
        if (this.payload && this.state.checkSisfoResponse && !this.isCommonCart) {
            return (React.createElement(React.Fragment, null, this.showBauCart()));
        }
        else if (this.payload && this.state.checkSisfoResponse && this.isCommonCart) {
            return (React.createElement(React.Fragment, null, this.showCommonCart()));
        }
        else {
            return (React.createElement(React.Fragment, null, " "));
        }
    };
    CartConfiguration.prototype.componentWillUnmount = function () {
        this.stateManager.set('sisfoMsgOnlyOncePerSession', { show: false });
        event_bus_1.ICCEventBusManager.getInstance().deregisterObserver(this.id);
    };
    CartConfiguration.prototype.getMonthlySavingsResponse = function (showMonthlySaving) {
        var _this = this;
        if (showMonthlySaving) {
            this.api.getMonthlySavings().then(function (response) {
                var _a, _b, _c;
                _this.monthlySavings = response;
                _this.setState({ isValidMonthlySavings: !!((_c = (_b = (_a = _this.monthlySavings) === null || _a === void 0 ? void 0 : _a.content) === null || _b === void 0 ? void 0 : _b.payload) === null || _c === void 0 ? void 0 : _c.planPrice) });
            }).catch(function (err) {
                _this.setState({ isValidMonthlySavings: false });
            });
        }
    };
    CartConfiguration.prototype.noBidForAdvertisment = function () {
        this.setState({ showAdvertismentBanner: false });
    };
    CartConfiguration.prototype.showPersonalizedPricingModal = function () {
        this.reportingService.fireLinkClickWithOutPageLoad(' Get started', ReportingService_1.PageUrls.CART_PAGE);
    };
    CartConfiguration.prototype.showAddALine = function () {
        var _this = this;
        var _a;
        var isAal = Utils.isAALFlow();
        var iconClasses = [icons.cccIconCart, icons.cccIconCartLg, icons.cccIconCartMobilesmartphone, wlsStyles.iconMobile];
        var redirectionUrl = this.isCommonCart ? '/buy/wireless/byod' :
            isAal ? '/buy/postpaid/phones' : '/buy/phones';
        return (React.createElement("div", { className: CartViewStyles.containerWidth },
            !Utils.isExpressUpgradeViewEnabled() && !isAal &&
                React.createElement("div", { className: CartViewStyles.solidLineLightGray }),
            React.createElement("div", { className: !isAal ? CartViewStyles.dueLineItems : '' },
                React.createElement("div", { className: !isAal ? wlsStyles.addALine : wlsStyles.addAnotherLine },
                    !isAal && React.createElement("span", { className: wlsStyles.addAlineIcon },
                        React.createElement("i", { className: iconClasses.join(' '), role: "img", "aria-label": "add a line" })),
                    React.createElement("h4", { className: wlsStyles.addAlineText },
                        React.createElement(components_1.Link, { kind: "textPlain", testId: utils_1.default('Cart', 'Link', 'Add'), className: CartCommon_scss_1.commonLinkMedium, 
                            // tslint:disable-next-line: jsx-no-lambda
                            onClick: function () {
                                cartUtils.isFNIntentPresent() && isAal ? _this.handleFNAddALineModal(true) :
                                    cartUtils.getRedirectionUrl('', redirectionUrl, 'Add another line');
                            } }, (_a = this.wlsCMS) === null || _a === void 0 ? void 0 : _a.addAnotherLineLabel))))));
    };
    CartConfiguration.prototype.renderUpsellPromoChangedBanner = function () {
        var _a, _b, _c, _d;
        if ((_b = (_a = this.payload) === null || _a === void 0 ? void 0 : _a.wirelessCart) === null || _b === void 0 ? void 0 : _b.upsellPromoChanged) {
            return (React.createElement("div", { className: styles.bannerContainer },
                React.createElement("i", { className: [icons.cccIconCart, icons.cccIconCartAlert, styles.alertWarnIcon].join(' '), "aria-hidden": "true" }),
                React.createElement("div", null,
                    React.createElement("span", { className: styles.bannerTextBold },
                        " ", (_c = this.wlsCMS) === null || _c === void 0 ? void 0 :
                        _c.upsellPromoChangedText,
                        " "),
                    React.createElement("span", { className: styles.bannerText },
                        " ", (_d = this.wlsCMS) === null || _d === void 0 ? void 0 :
                        _d.upsellPromoChangedDescription,
                        " "))));
        }
    };
    CartConfiguration.prototype.renderWireLessCart = function () {
        var _this = this;
        if (Utils.IsWirelessInCart()) {
            return (React.createElement(WirelessCart_1.default, { events: { onEdit: this.onLobEdit, doLoading: this.boolLoading }, options: {
                    autoExpandPromoSection: (this.props.options && this.props.options.autoExpandPromoSection) ? true : false,
                    isCommonCartBsse: this.isCommonCart,
                    monthlySavings: this.monthlySavings,
                    showBundlesTreatment: this.showBundlesTreatment,
                }, prepaidEvents: {
                    authSaveCartMessage: function () { return _this.authSaveCartMessage; },
                    onSubmit: function () { return _this.props && _this.props.events && _this.props.events.onSubmit; },
                }, promoPanelEvents: {
                    doLoading: this.boolLoading,
                    priceBarUpdates: this.cartPriceBarUpdates,
                    showSaveCartModal: this.showSaveCartModal,
                }, promoPanelOptions: {
                    autoExpandPromoSection: (this.props.options && this.props.options.autoExpandPromoSection) ? true : false,
                    displayCloserCoupon: (this.props.options && this.props.options.showCloserCoupons) ? true : false,
                } }));
        }
        else {
            return (React.createElement(React.Fragment, null, " "));
        }
    };
    CartConfiguration.prototype.renderLoginPanel = function () {
        return (React.createElement(React.Fragment, null));
        /* Note login panel code have moved to core-ui below is for debug only
        const redirectionURL = Utils.isLoginRequiredonCart() ? Utils.getauthenticatedPersistantLoginURL() : '';
        const isPrePreOrder = cartUtils.isPrePreOrder();
        return (
            <React.Fragment>
                {!isPrePreOrder &&
                    <div className={styles.cartContainer2}>
                        <LoginPanel
                            data={{
                                redirectToLoginURL: redirectionURL,
                                sisfoDisplayText: this.getSisfoLabel(),
                            }}
                        />
                    </div>
                }
            </React.Fragment>
        );
        */
    };
    CartConfiguration.prototype.renderCollapsedCart = function () {
        return (React.createElement(CollapsedCartView_1.default, { data: {
                cartCollapsed: (this.props.options && this.props.options.collapseCart) ?
                    true : false,
            }, events: {
                toggleExpandCollapseCart: (this.props.events && this.props.events.toggleExpandCollapseCart ?
                    this.props.events.toggleExpandCollapseCart : undefined),
            } }));
    };
    CartConfiguration.prototype.renderAdvertismentPanel = function () {
        var adConfig = this.advertismentCMSData.adConfig;
        var localData = {
            adConfiguration: adConfig,
            advHeading: this.advertismentCMSData.advertismentPanelHeading,
            enableAdvertisement: true,
            enableRTB: false,
        };
        return (React.createElement("div", { className: styles.cartContainer2, "data-test-id": utils_1.default('Cart', 'Advertisment', '_banner') },
            React.createElement(ui_components_1.Advertisement, { data: localData, id: "ad_att_cart", events: { noBidHandler: this.noBidForAdvertisment } })));
    };
    CartConfiguration.prototype.renderShareCartLink = function () {
        if (this.showShareCartLink) {
            return (React.createElement(React.Fragment, null,
                this.showSaveCartLinks && React.createElement("span", { className: styles.revDivider }),
                React.createElement(ShareCart_1.default, null)));
        }
        else {
            return (React.createElement(React.Fragment, null, " "));
        }
    };
    CartConfiguration.prototype.renderEmptyCartLink = function () {
        var eapContext = cartUtils.getEAPDetails();
        var isNewWireless = Utils.isNewWirelessFlow();
        if (Utils.isAuthuser() && eapContext.eapFlowType === 'AAL_EAP_ON'
            && eapContext.isEAPFlow && eapContext.deviceSubType === 'wearable') {
            return (React.createElement(React.Fragment, null));
        }
        else if (((Utils.isAuthuser()) || this.showSaveCartLinks)
            && !cartUtils.checkShareCartEligibility()) {
            return (React.createElement(React.Fragment, null,
                (this.showSaveCartLinks || this.showShareCartLink) && React.createElement("span", { className: styles.revDivider }),
                React.createElement(EmptyCart_1.default, null)));
        }
        else {
            return (React.createElement(React.Fragment, null,
                ((Utils.isAuthuser()) || this.showSaveCartLinks || this.showShareCartLink
                    || (wlsUtils.isCaribbeanFlow() && isNewWireless))
                    && React.createElement("span", { className: styles.revDivider }),
                React.createElement(EmptyCart_1.default, null)));
        }
    };
    CartConfiguration.prototype.renderUsername = function () {
        var _a, _b;
        var firstName = ((_b = (_a = this.payload) === null || _a === void 0 ? void 0 : _a.authDetails) === null || _b === void 0 ? void 0 : _b.firstName) || '';
        var displaySisfoLoginText = this.stateManager.get('CART', 'displayLoginSuccess');
        if (Utils.isAuthuser() && firstName !== '' && !wlsUtils.externalOrderSource(this.payload) &&
            !cartUtils.isFNIntentPresent()) {
            var updateNotifyPanel = this.stateManager.get(localdatastore_1.getNamespace('CART'), 'isNotificationPanel');
            if (!updateNotifyPanel || !updateNotifyPanel.loaded) {
                return (React.createElement("div", { className: styles.mb15 },
                    React.createElement(components_1.Alert, { closeable: true, onWhite: true, testId: utils_1.default('Cart', 'success', '_msg'), type: "info", style: displaySisfoLoginText && displaySisfoLoginText.displaySuccessMessage ?
                            styles.hideMessageIcon : '' },
                        React.createElement("div", { className: styles.mb10 }, displaySisfoLoginText && displaySisfoLoginText.displaySuccessMessage ?
                            React.createElement("div", null,
                                React.createElement("div", { className: styles.mb15 },
                                    React.createElement("span", null, firstName),
                                    ",",
                                    React.createElement("span", null,
                                        " ",
                                        this.cartSummaryCMSData.loginSuccessMessage)),
                                React.createElement("div", { className: styles.mb15 }, this.cartSummaryCMSData.userInfoLabel[0].toUpperCase() +
                                    this.cartSummaryCMSData.userInfoLabel.
                                        substring(1, this.cartSummaryCMSData.userInfoLabel.length - 1))) :
                            React.createElement("div", null,
                                React.createElement("span", null, firstName),
                                ",",
                                React.createElement("span", null,
                                    " ",
                                    this.cartSummaryCMSData.userInfoLabel))))));
            }
            else {
                return (React.createElement(React.Fragment, null, " "));
            }
        }
        else {
            return (React.createElement(React.Fragment, null, " "));
        }
    };
    CartConfiguration.prototype.renderPromoCard = function () {
        var _a, _b;
        var losgData = (_b = (_a = this.payload) === null || _a === void 0 ? void 0 : _a.wirelessCart) === null || _b === void 0 ? void 0 : _b.losgs;
        var externalOrderSourceType = wlsUtils.externalOrderSource(this.payload);
        if (this.isCommonCart || (this.savingsPromoFlags && this.savingsPromoFlags.savingsPromoComponentDisplay
            && !Utils.isPrepaidFlowType()) || externalOrderSourceType || Utils.IsAccessoryOnlyInCart() ||
            Utils.unauthenticatedAccess()) {
            return (React.createElement(React.Fragment, null, " "));
        }
        else {
            return (React.createElement(PromoPanel_1.default, { data: {
                    cartPage: true,
                    displayCloserCoupon: (this.props.options && this.props.options.showCloserCoupons) ? true : false,
                    losgData: losgData && Object.values(losgData),
                }, events: {
                    doLoading: this.boolLoading, priceBarUpdates: this.cartPriceBarUpdates,
                    showSaveCartModal: this.showSaveCartModal,
                }, options: {
                    autoExpandPromoSection: (this.props.options && this.props.options.autoExpandPromoSection) ? true : false,
                    isNewSavingsPromoComponent: this.isWirelessAccCart ? true : false,
                } }));
        }
    };
    CartConfiguration.prototype.renderAddMoreAccessory = function () {
        var _this = this;
        return Utils.getAccEditUrl() && (React.createElement("div", { className: styles.addMoreAccessoryLink },
            React.createElement("div", { className: promoStyle.innerDivider }),
            React.createElement(components_1.Link, { kind: "textPlain", testId: utils_1.default('Cart', 'Link', 'Add more accessory'), className: CartConfiguration_scss_1.rennyCommonLink, 
                // tslint:disable-next-line: jsx-no-lambda
                onClick: function () {
                    _this.onLobEdit('ACCESSORY', Utils.getAccEditUrl(), 'Add more accessory');
                    _this.reportingService.fireLinkClickWithOutPageLoad('Add more accessory', Utils.getAccEditUrl(), 'Body');
                } }, '+ Add more accessories'))) || React.createElement(React.Fragment, null);
    };
    CartConfiguration.prototype.renderBroadbandCart = function () {
        if (Utils.IsBroadbandInCart()) {
            return (React.createElement(React.Fragment, null,
                React.createElement(BroadbandCart_1.default, { data: {}, events: { onEdit: this.onLobEdit, doLoading: this.boolLoading }, options: { showBundlesTreatment: this.showBundlesTreatment } }),
                !this.state.isBundleCart && this.displayFutureBill() && this.renderFutureBill()));
        }
        else {
            return (React.createElement(React.Fragment, null, " "));
        }
    };
    CartConfiguration.prototype.renderAccessoriesCart = function () {
        if (Utils.IsAccessoryOnlyInCart()) {
            return (React.createElement(AccessoriesCart_1.default, { data: {}, events: { onEdit: this.onLobEdit, doLoading: this.boolLoading }, options: {
                    isCommonCart: this.isCommonCart,
                    showBundlesTreatment: this.showBundlesTreatment,
                }, promoPanelEvents: {
                    doLoading: this.boolLoading,
                    priceBarUpdates: this.cartPriceBarUpdates,
                    showSaveCartModal: this.showSaveCartModal,
                }, promoPanelOptions: {
                    autoExpandPromoSection: (this.props.options && this.props.options.autoExpandPromoSection) ? true : false,
                    displayCloserCoupon: (this.props.options && this.props.options.showCloserCoupons) ? true : false,
                } }));
        }
        else {
            return (React.createElement(React.Fragment, null, " "));
        }
    };
    CartConfiguration.prototype.renderFutureBill = function () {
        if (this.payload && this.payload.broadbandCart
            && (this.payload.broadbandCart.customerType === 'employee'
                || this.payload.broadbandCart.customerType === 'retiree')) {
            return (React.createElement(React.Fragment, null, " "));
        }
        else if (this.payload) {
            return (React.createElement("div", { className: styles.container783w },
                React.createElement(FutureBills_1.default, { data: this.payload, events: { doLoading: this.boolLoading } })));
        }
        else {
            return (React.createElement(React.Fragment, null, " "));
        }
    };
    CartConfiguration.prototype.renderIcompleteCart = function () {
        if (Utils.unauthenticatedAccess()) {
            return (React.createElement(React.Fragment, null, " "));
        }
        else {
            return (React.createElement("div", null,
                React.createElement(IncompleteCart_1.default, { data: {} })));
        }
    };
    CartConfiguration.prototype.getRTIErrorMessage = function (message) {
        if (Utils.unauthenticatedAccess()) {
            return (React.createElement(React.Fragment, null, " "));
        }
        else {
            var displayMessage = message && (React.createElement("div", { className: styles.mb10 }, React.createElement(components_1.Alert, { closeable: false, onWhite: true, testId: utils_1.default('Cart', 'RTIError', '_msg'), type: "error" },
                React.createElement(ui_components_2.Label, { data: {
                        text: message,
                    }, options: {
                        className: styles.rtiErrorMsg,
                    } }))));
            return displayMessage || React.createElement(React.Fragment, null);
        }
    };
    CartConfiguration.prototype.displayRtiErrorMessage = function () {
        var _a, _b, _c, _d, _e;
        var isAvailable = ((_b = (_a = this.payload) === null || _a === void 0 ? void 0 : _a.wirelessCart) === null || _b === void 0 ? void 0 : _b.deliveryMethods) &&
            !wlsUtils.isCommonDeliveryMethodAvailable(this.payload);
        var isOOSDevice = wlsUtils.isRTIOSSDevice(this.payload);
        var isCommonShipment = ((_e = (_d = (_c = this.payload) === null || _c === void 0 ? void 0 : _c.wirelessCart) === null || _d === void 0 ? void 0 : _d.deliveryMethods) === null || _e === void 0 ? void 0 : _e.length) > 0 &&
            this.payload.wirelessCart.deliveryMethods.indexOf('DF') === -1 &&
            (this.payload.wirelessCart.deliveryMethods.indexOf('C2S') !== -1 ||
                this.payload.wirelessCart.deliveryMethods.indexOf('RTG') !== -1);
        var displayCommonDeliveryMessage = this.wlsCMS && this.wlsCMS.noRtiCommonDeliveryMessage &&
            this.getRTIErrorMessage(this.wlsCMS.noRtiCommonDeliveryMessage);
        var displayOOSErrorMessage = this.wlsCMS && this.wlsCMS.rtiOOSMessage &&
            this.getRTIErrorMessage(this.wlsCMS.rtiOOSMessage);
        var displayShipingText = this.wlsCMS && this.wlsCMS.rtiC2SCartLevelText &&
            this.getRTIErrorMessage(this.wlsCMS.rtiC2SCartLevelText);
        var displayNoCommonDeliveryText = this.getRTINoCommonDeliveryErrorMessage(this.wlsCMS);
        if (Utils.unauthenticatedAccess()) {
            return (React.createElement(React.Fragment, null, " "));
        }
        else {
            return (React.createElement("div", null, isOOSDevice ? displayOOSErrorMessage : isAvailable ? displayCommonDeliveryMessage :
                isCommonShipment ? displayShipingText : this.state.showRtiNoCommonDeliveryError ?
                    displayNoCommonDeliveryText : React.createElement(React.Fragment, null)));
        }
    };
    CartConfiguration.prototype.showSaveCartModal = function () {
        this.savecartModalRef.current.triggerSaveCartModal();
    };
    CartConfiguration.prototype.saveRetrieveCart = function () {
        var _this = this;
        return (React.createElement(SaveRetrieveCart_1.default, { ref: this.savecartModalRef, data: { payload: this.payload }, events: {
                authSaveErrorMsg: this.authSaveCartMessage,
                emailInfoUpdated: function () { return _this.props.events.onSubmit; },
            } }));
    };
    CartConfiguration.prototype.getSisfoLabel = function () {
        var _this = this;
        var text = '';
        if (this.payload
            && this.payload.sisfoStoreDetail) {
            if (this.finalLobOrigin && this.finalLobOrigin._cartOrigin &&
                this.finalLobOrigin._cartOrigin.toUpperCase() === 'OPUS-CARE') {
                text = this.cartSummaryCMSData.sicfoAvailableBodyMessageLabel;
            }
            else {
                var storeName = this.payload.sisfoStoreDetail.storeName;
                if (this.finalLobOrigin) {
                    var logsList_1 = this.finalLobOrigin.losgs;
                    if (logsList_1) {
                        Object.keys(logsList_1).forEach(function (losgKey) {
                            var losg = logsList_1[losgKey];
                            if (losg && losg.compensation) {
                                Object.keys(losg.compensation).forEach(function (repDetails) {
                                    if (losg.compensation[repDetails] && losg.compensation[repDetails][0]) {
                                        _this.agentName = losg.compensation[repDetails][0]._agentFirstName;
                                    }
                                });
                            }
                        });
                    }
                }
                var dynTxtArry = [
                    { textVal: "<b>" + storeName + "</b>", replacewith: 'Y' },
                    { textVal: "<b>" + this.agentName + "</b>", replacewith: 'X' },
                ];
                text = Utils.cmsDynamicContent(this.cartSummaryCMSData.sisfoAvailableBodyMessageLabel, dynTxtArry);
            }
        }
        return text;
    };
    CartConfiguration.prototype.renderSisfoAlert = function () {
        if (this.finalLobOrigin && this.finalLobOrigin._cartOrigin &&
            (/OPUS/i).test(this.finalLobOrigin._cartOrigin) &&
            this.payload &&
            this.sisfoMessageOnlyOncePerSession()) {
            return (React.createElement("div", null, !this.payload.displayLoginOption &&
                React.createElement("div", { className: styles.sisfoPanel },
                    React.createElement(components_1.Alert, { closeable: true, onWhite: true, testId: 'SISFO_Cart_Message', type: "info" },
                        React.createElement("div", { className: styles.secondlabelSisfo },
                            React.createElement(ui_components_2.Label, { data: {
                                    text: this.cartSummaryCMSData.sisfoAvailableNewMessageLabel + " " + this.getSisfoLabel(),
                                } })),
                        React.createElement("div", { className: styles.secondlabelSisfo },
                            React.createElement(ui_components_2.Label, { data: { text: "Oh! And we've updated your cart with our best online prices and offers!" } }))))));
        }
        else {
            return (React.createElement(React.Fragment, null, " "));
        }
    };
    CartConfiguration.prototype.renderContentChangeMessage = function () {
        var _a, _b, _c, _d;
        if (((_d = (_c = (_b = (_a = this.payload) === null || _a === void 0 ? void 0 : _a.wirelessCart) === null || _b === void 0 ? void 0 : _b._cartInitializationDetails) === null || _c === void 0 ? void 0 : _c.status) === null || _d === void 0 ? void 0 : _d.toLowerCase()) === 'change') {
            return (React.createElement("div", { className: styles.cartContainer2 },
                React.createElement(components_1.Alert, { closeable: true, onWhite: true, testId: utils_1.default('Cart', 'CartContentChange', '_msg'), type: "info" }, this.saveRetrieveCMSData.savedCartItemRemovedTxt)));
        }
        else {
            return (React.createElement(React.Fragment, null, " "));
        }
    };
    CartConfiguration.prototype.renderSharedRetrieveCartMessage = function () {
        if (cartUtils.isSharedRetrievedCart()) {
            return (React.createElement("div", { className: styles.cartContainer2 },
                React.createElement(components_1.Alert, { closeable: true, onWhite: true, testId: utils_1.default('Cart', 'sharedRetrieve', '_msg'), type: "info" }, this.cartSummaryCMSData.sharedRetrieveMessage)));
        }
        else {
            return (React.createElement(React.Fragment, null, " "));
        }
    };
    CartConfiguration.prototype.renderOrderTotals = function () {
        var isBundle = Utils.isBundleinCart().isBundleWithoutDTVNorAccessory;
        if (this.payload && isBundle && this.showBundlesTreatment) {
            return (React.createElement(OrderTotals_1.default, null));
        }
        else {
            return (React.createElement(React.Fragment, null, " "));
        }
    };
    CartConfiguration.prototype.displayFutureBill = function () {
        if (this.props && this.props.options && (!this.props.options.showFutureBillEstimator ||
            Utils.IsWirelessInCart())) {
            if (Utils.IsBroadbandInCart()) {
                return true;
            }
            else {
                return false;
            }
        }
        else {
            return true;
        }
    };
    CartConfiguration.prototype.displaySisfoLoginPanel = function () {
        if (this.props && this.props.options && !this.props.options.showSisfoLoginPanel) {
            return false;
        }
        else {
            return true;
        }
    };
    CartConfiguration.prototype.showErrorMessage = function () {
        if (this.state.isShowErrorMessage) {
            return (React.createElement("div", null,
                React.createElement(components_1.Alert, { closeable: true, onWhite: true, testId: 'Save_Cart_Error_InfoMsg', type: this.errorMsgIconType === MessageProps_1.MessageType.INFO ? 'info' : 'error' }, this.errorMsgText)));
        }
        else {
            return (React.createElement(React.Fragment, null, " "));
        }
    };
    CartConfiguration.prototype.renderExpressView = function () {
        var _this = this;
        var _a, _b, _c, _d, _e;
        var isNewWireless = cartUtils.isNewWirelessPostpaidView();
        var isExpCollapsed = true;
        var isExpViewExpanded = this.stateManager.get(localdatastore_1.getNamespace('APPSHELL'), 'isExpViewExpanded');
        var eSimEligible = false;
        var isAndroidDevice = cartUtils.checkShareCartEligibilityForAndroid();
        var isPSC = ((_b = (_a = this.payload) === null || _a === void 0 ? void 0 : _a.wirelessCart) === null || _b === void 0 ? void 0 : _b._cartCreationSource) === 'PSC';
        var eapContext = cartUtils.getEAPDetails();
        var isCarribeanUser = cartUtils.isFNCarribeanUser();
        if ((isExpViewExpanded && isExpViewExpanded.isViewExpanded) || (this.payload
            && this.payload.enableExpandedCartView) || cartUtils.isIncompleteCart() || Utils.isLoginRequiredonCart()) {
            isExpCollapsed = false;
        }
        if (isAndroidDevice) {
            isExpCollapsed = true;
        }
        if ((_d = (_c = this.payload) === null || _c === void 0 ? void 0 : _c.wirelessCart) === null || _d === void 0 ? void 0 : _d.losgs) {
            Object.values(this.payload.wirelessCart.losgs).forEach(function (losg) {
                eSimEligible = wlsUtils.isBYODAndEsim(losg) && Utils.getIXPValue('svc-byod-esim-aal');
            });
        }
        return (React.createElement("div", null,
            " ",
            this.CRPLaterOfferMessage(),
            this.displaySisfoLoginPanel() && this.renderLoginPanel(),
            this.showPersonalizedPricing(),
            this.renderMonthlySavings(),
            this.renderUpsellPromoChangedBanner(),
            this.renderIcompleteCart(),
            Utils.isEnableValidateInventory() && this.displayRtiErrorMessage(),
            this.showCouponReminder(),
            this.displayFNModal(isCarribeanUser),
            ((_e = this.payload) === null || _e === void 0 ? void 0 : _e.isAccountLocked) &&
                React.createElement("div", { className: styles.containerB }, this.renderAccountLockMessage(this.wlsCMS)),
            React.createElement(ExpressView_1.default, { data: {
                    autoExpandPromoSection: (this.props.options && this.props.options.autoExpandPromoSection) ? true : false,
                    isCollapsed: isExpCollapsed, isExpressUpgradeView: this.isExpressUpgradeView,
                    savingsPromoComponentDisplay: this.savingsPromoFlags && this.savingsPromoFlags.savingsPromoComponentDisplay,
                }, events: { onEdit: this.onLobEdit, doLoading: this.boolLoading }, promoPanelEvents: {
                    doLoading: this.boolLoading,
                    priceBarUpdates: this.cartPriceBarUpdates,
                    showSaveCartModal: this.showSaveCartModal,
                }, promoPanelOptions: {
                    autoExpandPromoSection: (this.props.options && this.props.options.autoExpandPromoSection) ? true : false,
                    displayCloserCoupon: (this.props.options && this.props.options.showCloserCoupons) ? true : false,
                }, crpEvents: { crpStandaloneMessage: function () { return _this.handleStandaloneCRPMessage; } } }),
            (!this.showBundlesTreatment || !this.state.isBundleCart) &&
                !Utils.unauthenticatedAccess() && this.renderPromoCard(),
            !Utils.unauthenticatedAccess() && this.payload && ((!isNewWireless &&
                ((this.payload.wirelessCart && this.payload.wirelessCart.addAnotherDeviceEligible) ||
                    (this.isCommonCart && this.payload.commonCart.addAnotherDeviceEligible) ||
                    (isPSC && Utils.isAALFlow() && this.payload.wirelessCart.addAnotherDeviceEligible))) ||
                eSimEligible)
                && this.showAddALine()));
    };
    CartConfiguration.prototype.renderMonthlySavings = function () {
        if ((Utils.IsWirelessInCart() || this.isCommonCart) && !Utils.unauthenticatedAccess()) {
            if (this.isExpressUpgradeView) {
                return (React.createElement("div", null,
                    React.createElement(MonthlySavings_1.default, { data: {
                            monthlySavings: this.monthlySavings,
                            showMonthlySaving: this.state.isValidMonthlySavings,
                        } }),
                    React.createElement("div", null, this.changePlanOfferMessage())));
            }
            else {
                return (React.createElement("div", { className: styles.containerB },
                    React.createElement(MonthlySavings_1.default, { data: {
                            monthlySavings: this.monthlySavings,
                            showMonthlySaving: this.state.isValidMonthlySavings,
                        } }),
                    this.changePlanOfferMessage()));
            }
        }
        else {
            return (React.createElement(React.Fragment, null, " "));
        }
    };
    CartConfiguration.prototype.changePlanOfferMessage = function () {
        var _a, _b;
        if ((_b = (_a = this.payload) === null || _a === void 0 ? void 0 : _a.wirelessCart) === null || _b === void 0 ? void 0 : _b.enableChangePlanOffer) {
            return (React.createElement("div", null,
                React.createElement(components_1.Alert, { closeable: true, onWhite: true, testId: utils_1.default('Cart', 'changePlanOffer', 'msg'), type: "error" },
                    React.createElement(ui_components_2.Label, { testId: utils_1.default('Cart', 'changePlanOffer', 'label'), data: { text: this.wlsCMS.changePlanOfferLabel }, options: { className: styles.changePlanOffer } }))));
        }
        else {
            return (React.createElement(React.Fragment, null, " "));
        }
    };
    CartConfiguration.prototype.showBauCart = function () {
        var _a, _b, _c, _d, _e, _f, _g;
        this.lobList = Utils.getLobList();
        return (React.createElement(React.Fragment, null,
            React.createElement(ui_components_1.Console, null,
                (!this.isExpressUpgradeView || this.isWirelessAccCart) &&
                    React.createElement("div", { "data-test-id": CartConfiguration.name },
                        this.displayCartInCollapsedMode &&
                            React.createElement("div", { className: [styles.container,
                                    styles.cartContainer,
                                    styles.boxshadow,
                                    (this.props.options && !this.props.options.collapseCart) ?
                                        styles.shadowBottomNone : '',
                                    styles.collapsedCartContainer].join(' ') }, this.renderCollapsedCart()),
                        (!this.displayCartInCollapsedMode ||
                            (this.props.options && !this.props.options.collapseCart)) &&
                            React.createElement("div", { className: styles.container },
                                !this.isExternalOrderSource && !Utils.unauthenticatedAccess() &&
                                    React.createElement("div", { className: this.displayCartInCollapsedMode ?
                                            styles.linksContainerTopCollapsedcart : styles.linksContainerTop },
                                        React.createElement("div", null,
                                            this.showSaveCartLinks && this.saveRetrieveCart(),
                                            this.renderShareCartLink(),
                                            this.renderEmptyCartLink())),
                                this.renderLoading(),
                                this.displaySisfoLoginPanel() && this.renderLoginPanel(),
                                this.renderSharedRetrieveCartMessage(),
                                ((_a = this.payload) === null || _a === void 0 ? void 0 : _a.isAccountLocked) &&
                                    React.createElement("div", { className: [styles.containerA, 'mar-b-sm'].join(' ') }, this.renderAccountLockMessage(this.wlsCMS)),
                                this.renderContentChangeMessage(),
                                this.showErrorMessage(),
                                this.renderMonthlySavings(),
                                React.createElement("div", { className: styles.containerA },
                                    this.renderUpsellPromoChangedBanner(),
                                    this.showPersonalizedPricing(),
                                    this.renderSisfoAlert(),
                                    this.renderIcompleteCart(),
                                    Utils.isEnableValidateInventory() && this.displayRtiErrorMessage(),
                                    ((_c = (_b = this.payload) === null || _b === void 0 ? void 0 : _b.wirelessCart) === null || _c === void 0 ? void 0 : _c.insuranceItemRemoved) && this.displayInsuranceRemovalAlert(),
                                    this.displayInsuranceUpdatedAlert((_e = (_d = this.payload) === null || _d === void 0 ? void 0 : _d.wirelessCart) === null || _e === void 0 ? void 0 : _e.losgs),
                                    this.showCouponReminder(),
                                    this.showAllPlansUpadatedWarningMsg(this.payload, (_f = this.wlsCMS) === null || _f === void 0 ? void 0 : _f.multidevicePlanUpdateMsg),
                                    this.showTVLaterBBExperience && this.onlyBBInCartWithSessionData &&
                                        this.renderTVLaterAlert(this.cartConfigurationCMSData.userInfoTVLaterMessage, this.cartConfigurationCMSData.userInfoTVLaterSubMessage, this.cartConfigurationCMSData.userInfoTVLaterPhone)),
                                React.createElement("div", { className: [styles.cartContainer,
                                        styles.boxshadow,
                                        this.displayCartInCollapsedMode ? styles.shadowBottomNone : ''].join(' ') },
                                    this.renderOrderTotals(),
                                    this.showBundlesTreatment && this.state.isBundleCart &&
                                        this.displayFutureBill() &&
                                        React.createElement(React.Fragment, null,
                                            this.renderFutureBill(),
                                            this.renderPromoCard()),
                                    this.renderUsername(),
                                    this.renderWireLessCart(),
                                    (((_g = this.lobList) === null || _g === void 0 ? void 0 : _g.length) === 1 &&
                                        this.lobList[0].toUpperCase() === 'BUSINESSAPPS') &&
                                        React.createElement(BusinessTools_1.default, { data: { isStandaloneBusiness: true }, events: { onEdit: this.onLobEdit, doLoading: this.boolLoading } }),
                                    this.renderBroadbandCart(),
                                    this.renderAccessoriesCart(),
                                    (!this.showBundlesTreatment || !this.state.isBundleCart) &&
                                        ((!this.showTVLaterBBExperience && this.renderPromoCard()) ||
                                            (!this.onlyBBInCartWithSessionData && this.renderPromoCard())),
                                    !this.showBundlesTreatment && this.state.isBundleCart &&
                                        this.displayFutureBill() && this.renderFutureBill()),
                                this.showTVLaterBBExperience && this.onlyBBInCartWithSessionData &&
                                    React.createElement("div", { className: "mar-t-xxs" },
                                        React.createElement("div", { className: [styles.cartContainer,
                                                styles.boxshadow,
                                                this.displayCartInCollapsedMode ? styles.shadowBottomNone : ''].join(' ') },
                                            this.tvLaterComp(this.cartConfigurationCMSData.tvHeading, this.cartConfigurationCMSData.tvLaterAlertContent),
                                            (!this.showBundlesTreatment || !this.state.isBundleCart) &&
                                                this.showTVLaterBBExperience && this.onlyBBInCartWithSessionData &&
                                                this.renderPromoCard())),
                                this.advertismentCMSData &&
                                    this.advertismentCMSData.displayAdvertismentPanelMasterFlag &&
                                    this.advertismentCMSData.displayAdvertismentPanelMasterFlag
                                        .toString().toUpperCase() === 'TRUE' &&
                                    this.props && this.props.options && this.props.options
                                    .showAdvertisementPanel &&
                                    this.state.showAdvertismentBanner &&
                                    this.renderAdvertismentPanel())),
                this.isExpressUpgradeView &&
                    React.createElement("div", { className: styles.container },
                        !this.isExternalOrderSource && !Utils.unauthenticatedAccess() &&
                            React.createElement("div", { className: this.displayCartInCollapsedMode ?
                                    styles.linksContainerTopCollapsedcart : styles.linksContainerTop },
                                React.createElement("div", { className: !this.showSaveCartLinks ?
                                        '' : styles.linksContainerTopHidden }, this.renderEmptyCartLink())),
                        this.renderLoading(),
                        React.createElement("div", { className: styles.expupCartContainer, "data-test-id": CartConfiguration.name }, this.renderExpressView()))),
            this.state.showInsuranceModal && (React.createElement(InsuranceModel_1.default, { data: this.state.showInsuranceModal, checkout: this.state.insuranceModalFromCheckout, cmscontent: {
                    moreInsuranceOptions: this.cartConfigurationCMSData.moreInsuranceOptions,
                    moreInsuranceOptionsLog: this.cartConfigurationCMSData.moreInsuranceOptionsLog,
                    zipChangeOKLabel: this.cartConfigurationCMSData.zipChangeOKLabel,
                } }))));
    };
    CartConfiguration.prototype.displayInsuranceRemovalAlert = function () {
        var _this = this;
        var pscEditUrl = '';
        var losgsData = Object.values(cartUtils.getWirelessCart().wirelessCart.losgs);
        losgsData.forEach(function (item) {
            if (item.sequence === 1) {
                pscEditUrl = item.pscEditUrl;
            }
        });
        return (React.createElement("div", { className: styles.mb10 }, React.createElement(components_1.Alert, { closeable: true, onWhite: true, testId: utils_1.default('Cart', 'InsuranceRemoved', '_msg'), type: "warning" },
            React.createElement(ui_components_2.Label, { data: {
                    text: this.cartSummaryCMSData.insuranceRemovedAlertText,
                }, options: {
                    className: styles.rtiErrorMsg,
                } }),
            React.createElement(ui_components_2.Label, { data: {
                    text: this.cartSummaryCMSData.addInsuranceLabel,
                }, options: {
                    className: styles.rtiErrorMsg,
                } }),
            React.createElement(components_1.Link, { kind: "textPlain", testId: utils_1.default('addInsurance', 'Link', 'Modal'), className: styles.commonLinkSmall, icon: React.createElement(components_1.IconSvg, { size: 16, svgNodeStr: Utils.GET_ICON_SVG.UP }), 
                // tslint:disable-next-line: jsx-no-lambda
                onClick: function () {
                    _this.onLobEdit('WIRELESS', pscEditUrl, _this.cartSummaryCMSData.addInsuranceLink);
                } }, this.cartSummaryCMSData.addInsuranceLink))));
    };
    CartConfiguration.prototype.showCommonCart = function () {
        return (React.createElement(ui_components_1.Console, null,
            React.createElement("div", { className: styles.container },
                this.renderMonthlySavings(),
                React.createElement("div", { className: styles.containerB },
                    " ",
                    this.renderIcompleteCart(),
                    " "),
                React.createElement("div", { className: styles.pannelContainer },
                    this.renderWireLessCart(),
                    this.renderAccessoriesCart()))));
    };
    CartConfiguration.prototype.showPersonalizedPricing = function () {
        var _this = this;
        var isPrescreenCreditCheckOnCart = cartUtils.isEnablePrescreenCreditCheckOnCart();
        var url = location.href.toLowerCase();
        var isParamVal = (/source=/i).test(url);
        var isNewWireless = Utils.isNewWirelessFlow();
        // expected ?source=
        if (isPrescreenCreditCheckOnCart && isParamVal && isNewWireless) {
            var linkText = this.cartSummaryCMSData.personalizedPricingLink || ' Get started ';
            return (React.createElement("div", null,
                React.createElement(components_1.Alert, { closeable: true, onWhite: true, testId: utils_1.default('Cart', 'success', '_msg'), className: styles.hideAlertIcon },
                    React.createElement(ui_components_2.Label, { data: {
                            isDecodingRequired: false, text: this.cartSummaryCMSData.personalizedPricingTitle || 'Get personalized pricing',
                        }, options: { className: styles.rennyErrormsg, size: LabelProps_1.LabelSizes.MEDIUM } }),
                    React.createElement("div", null,
                        React.createElement("span", null,
                            React.createElement(ui_components_2.Label, { data: {
                                    isDecodingRequired: false, text: this.cartSummaryCMSData.personalizedPricingLabel
                                        || 'See what you qualify for upfront—without hurting your credit score. ',
                                }, options: { className: styles.normalContent } })),
                        React.createElement("span", null,
                            React.createElement(components_1.Link, { kind: "textPlain", testId: utils_1.default('personalizedPricing', 'Link', 'Modal'), 
                                // tslint:disable-next-line: jsx-no-lambda
                                onClick: function () { _this.showPersonalizedPricingModal(); }, className: styles.commonLinkSmall, icon: React.createElement(components_1.IconSvg, { size: 16, svgNodeStr: Utils.GET_ICON_SVG.UP }) }, linkText))))));
        }
        else {
            return (React.createElement(React.Fragment, null, " "));
        }
    };
    return CartConfiguration;
}(CartConfigurationExtender_1.default));
exports.default = CartConfiguration;
//# sourceMappingURL=CartConfiguration.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/cart-ui/components/CartConfigurationContainer/CartConfiguration.js
// module id = 759
// module chunks = 8